import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, throwError, timer } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { global } from '../global';

@Injectable({
    providedIn: 'root',
})
export class RealTimeService {

  public urlApiibrk: string;
  public urlApi: string;
  constructor(private http: HttpClient) {
    this.urlApiibrk=global.session.baseUrl;
    this.urlApi=global.url;
  }

  fetchDataEverySecond(url: any): Observable<any> {
    let apiUrl = this.urlApi+url;
    return interval(1000).pipe(
      switchMap(() => this.http.get<any>(apiUrl))
    );
  }

  fetchDataEvery60Secondapi(endpoint: string, data:any, licencia:string): Observable<any> {
    const url = `${this.urlApi}${endpoint}`;
    return timer(0, 60000).pipe(
      switchMap(() => this.http.post(url, data, {
        headers: {
          licencia: licencia,
          "Content-Type": "application/json",
        },
      }).pipe(
        catchError(error => {
          // Maneja el error aquí
          console.error('Error al obtener datos:', error);
          return throwError(error); 
        })
      ))
    );
  }

  
 /**
  *  consultaunaSola(endpoint: string): Observable<any> {
    const url = `${this.urlApiibrk}${endpoint}`;
    return this.http.get<any>(url)
  }

  */

}